/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface SupportOrderRequest {
  /** @format uuid */
  topicId: string;
  description: string;
  agreementNumber: string;
}

export interface OrderResponse {
  /** @format uuid */
  id?: string;
}

/**
 * Сообщение об ошибке
 */
export interface ErrorMessage {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

export interface StoreOrderRequest {
  /**
   * Номер договора торгового эквайринга
   * @example ЕЭД12345678/0001
   */
  agreementNumber?: string;

  /**
   * Контактный телефон
   * @example +79999999999
   */
  contactPhoneNumber?: string;

  /**
   * Электронная почта (e-mail)
   * @example example@mail.ru
   */
  clientEmail?: string;

  /**
   * Название торговой точки (указанное на вывеске/место приема платежей)
   * @example Экзеймпл стор
   */
  storeName?: string;

  /**
   * Адрес местонахождения торговой точки с индексом
   * @example г. Владивосток, ул. Ленина, д. 23, Индекс: 224451
   */
  storeAddress?: string;

  /**
   * Код ОКАТО
   * @example 36234836003
   */
  storeOkato?: string;

  /**
   * Режим работы
   * @example ПН-ПТ 07.30-19.00, СБ-ВС 10.00-17.00
   */
  storeWorkMode?: string;

  /**
   * Профиль торговой точки (вид деятельности)
   * @example 5047
   */
  storeMcc?: string;

  /** Необходимые виды оборудования для ТСП */
  equipmentTypes?: ("POS_TERMINAL" | "ONLINE_CASH_REGISTER")[];

  /** Конкретные типы оборудования для ТСП */
  deviceTypes?: ("STATIC" | "PORTABLE")[];

  /** Необходимые способы подключения ТСП */
  connectionTypes?: ("INTERNET" | "SIM" | "WI_FI")[];

  /**
   * ФИО ответственного лица
   * @example Иванов Олег Михайлович
   */
  responsiblePersonFullName?: string;

  /**
   * Телефон ответственного лица
   * @example +79990990909
   */
  responsiblePersonPhone?: string;

  /**
   * Эл. адрес для запросов по финансовым операциям
   * @example financial_example@mail.ru
   */
  emailForFinancialOperations?: string;

  /**
   * Эл. адрес для получения отчетности /корреспонденции
   * @example report_example@mail.ru
   */
  emailForReports?: string;

  /**
   * Расчетный счет
   * @example 40702810800000012345
   */
  checkingAccount?: string;

  /**
   * Наименование Банка
   * @example АО Россельхозбанк
   */
  bankName?: string;

  /**
   * БИК Банка
   * @example 044525111
   */
  bankBik?: string;

  /**
   * Корреспондентский счет
   * @example 30101810400000000225
   */
  correspondentAccount?: string;

  /**
   * Код ОКТМО (Общероссийский классификатор территорий муниципальных образований)
   * @example 45374000
   */
  oktmo?: string;

  /**
   * Код ОКВЭД (Общероссийский классификатор видов экономической деятельности)
   * @example 51.47.15
   */
  okved?: string;

  /**
   * Код ОКПО (Общероссийский классификатор предприятий и организаций)
   * @example 52750822
   */
  okpo?: string;

  /**
   * КБК (Код бюджетной классификации)
   * @example 18210606033101000110
   */
  kbk?: string;

  /**
   * Лицевой счет
   * @example 1234567890
   */
  personalAccount?: string;
}

export interface MerchantAccountInfo {
  isInner?: boolean;
  accountType?: "DEBIT_COMMISSION_ACCOUNT" | "REFUND_ACCOUNT";
  paymentAccNum?: string;
  bankName?: string;
  bankBic?: string;
  corAccountNum?: string;
  oktmo?: string;
  kbk?: string;
  personalAccountNum?: string;
}

export interface MerchantClientInfo {
  fullName?: string;
  chiefFIO?: string;
  inn?: string;
  kpp?: string;
  address?: string;
}

export interface MerchantContactInfo {
  contactType?: "TECH_EMAIL" | "CLIENT_SITE";
  contactValue?: string;
}

export interface MerchantDraft {
  /** @format uuid */
  id?: string;
  requestNum?: string;
  basedOn?: "REGULATION" | "ATTORNEY";
  clientInfo?: MerchantClientInfo;
  contactPhone?: string;
  contactEmail?: string;
  financialEmail?: string;
  reportEmail?: string;
  reportPeriod?: "DAILY" | "MONTHLY";
  isBudget?: boolean;
  isLicenseNeeded?: boolean;
  isSingleRefundForPoints?: boolean;
  isRefundSingleWithDebit?: boolean;
  refundPeriod?: "AT_DAY" | "ONE_DAY";
  tradePoints?: MerchantTradePoint[];
  contactInfos?: MerchantContactInfo[];
  accountInfos?: MerchantAccountInfo[];
  signingInfos?: SigningInfo[];

  /** @format date-time */
  createDate?: string;

  /** @format date-time */
  updateDate?: string;
  status?: OrderStatus;
}

export interface MerchantPosTerminal {
  alignment?: "BANK" | "CLIENT" | "PARTNER";

  /** @format int32 */
  quantity?: number;
  terminalType?: "STATIONARY" | "MOVABLE" | "CASH_SOLUTION";
  isConnectionCable?: boolean;
  isConnectionSim?: boolean;
  isConnectionWifi?: boolean;
  isConnectionCash?: boolean;
  isTipsEnabled?: boolean;
}

export interface MerchantTradePoint {
  /** @format uuid */
  id?: string;
  isFilled?: boolean;
  pointName?: string;
  address?: string;
  activitySector?: string;
  activityKind?: string;
  oktmo?: string;
  workTime?: string;
  responsibleFio?: string;
  responsiblePhone?: string;
  isSoftPosUsing?: boolean;
  mccCode?: string;
  accountInfo?: MerchantAccountInfo;
  posTerminals?: MerchantPosTerminal[];
}

export interface OrderStatus {
  /** @example NEW */
  id?:
    | "NEW"
    | "PARTIALLY_SIGNED"
    | "SIGNED"
    | "ANTI_FRAUD_ANALYZE"
    | "IN_PROCESS"
    | "COMPLETED"
    | "OUT_OF_DATE"
    | "ERROR"
    | "ON_REVIEW"
    | "REJECTED";

  /** @example Новый */
  description?: string;
}

export interface SigningInfo {
  signOwnerFIO?: string;
  contractNum?: string;

  /** @format date-time */
  signDate?: string;
  signMethod?: string;
}

export interface MerchantRegistrationRequest {
  /**
   * Название ТСП (имя по вывеске)
   * @example Кофейня у Артема
   */
  brandName?: string;

  /**
   * Номер счета юридического лица, привязанного к ТСП
   * @example 40702810100010000001
   */
  account: string;

  /**
   * Номер счета юридического лица, привязанного к ТСП, для списания комиссии
   * @example 40702810100010000001
   */
  commissionAccount: string;

  /**
   * MCC код
   * @example 4122
   */
  mcc: string;

  /**
   * Код страны-регистрации юридического лица, в формате "ISO 3166, Alpha-2"
   * @example RU
   */
  countryCode: string;

  /**
   * Код региона-регистрации юридического лица, первые две цифры кода ОКТМО
   * @example 45
   */
  countrySubDivisionCode: string;

  /**
   * Город
   * @example Москва
   */
  city?: string;

  /**
   * Индекс
   * @example 115184
   */
  zip?: string;

  /**
   * Фактический адрес ТСП
   * @example УЛИЦА ТАТАРСКАЯ Б. ДОМ 11
   */
  address?: string;

  /**
   * Контактный номер телефона ТСП
   * @example 89991234567
   */
  contactPhoneNumber?: string;

  /**
   * Номер телефона ТСП для отправки уведомлений
   * @example 89991234567
   */
  notificationPhoneNumber?: string;
}

export interface MerchantUpdateRequest {
  /**
   * Номер телефона ТСП для отправки уведомлений
   * @example +79991234567
   */
  notificationPhoneNumber?: string;

  /**
   * Номер счета юридического лица, привязанного к ТСП
   * @example 40702810100010000001
   */
  account?: string;

  /**
   * Номер счета юридического лица, привязанного к ТСП, для списания комиссии
   * @example 40702810100010000001
   */
  commissionAccount?: string;
}

export interface StatusEntity {
  /**
   * Статус юр. лица / ТСП
   * @example BLOCK
   */
  status?: "ACTIVE" | "BLOCK";
  description?: string;
}

export interface FindAddressRequest {
  /** @example Хабаровский край */
  region: string;

  /** @example Комсомольск-на-Амуре */
  city?: string;

  /** @example Ванино */
  settlement?: string;

  /** @example Лен */
  street?: string;
}

export interface FindAddressResponse {
  fullAddress?: string;

  /**
   * Регион
   * @example г Санкт-Петербург
   */
  region?: string;

  /**
   * Город
   * @example г Санкт-Петербург
   */
  city?: string;

  /**
   * Улица
   * @example Ленинский пр-кт
   */
  street?: string;

  /**
   * Код ОКАТО
   * @example 40279562000
   */
  house?: string;

  /** Корпус */
  building?: string;

  /** Строение */
  housing?: string;

  /** Квартира */
  flat?: string;
  okato?: string;

  /**
   * Почтовый индекс
   * @example 427140
   */
  postalCode?: string;
}

export interface DocumentFileResponse {
  /** @format uuid */
  id?: string;
  name?: string;
  status?:
    | "CREATE"
    | "TEMP"
    | "ANTIVIRUS"
    | "CLEAN"
    | "REJECT"
    | "DONE"
    | "ERROR";
  documentType?:
    | "ACTIVITY_LICENSE"
    | "PDN_ACCEPTANCE"
    | "REGULATION"
    | "ORG_REGULATION"
    | "FOUND_AGREEMENT"
    | "CONTRACT_ORDER_CONFIRM"
    | "EIO_CONFIRM"
    | "EGRUL"
    | "EGRIP"
    | "ACTIVITY_PATENT"
    | "ACTIVITY_CERTIFICATE"
    | "REPRESENTATIVE_LETTER"
    | "SIGN_INSTANCES"
    | "ROOM_RIGHTS"
    | "POINT_PHOTO"
    | "JOIN_REQUEST"
    | "OTHER";
}

export interface Money {
  /**
   * Сумма в копейках
   * @example 100000
   */
  amount: number;

  /**
   * Валюта операции:
   *
   * RUB - Российский рубль
   * @example RUB
   */
  currencyCode: "RUB";
}

export interface PaymentOperationRequest {
  /**
   * Идентификатор Платежной ссылки СБП
   * @example AO1000670LSS7DN18SJQDNP4B05KLJL2
   */
  qrcId: string;
  amount?: Money;
  totalTaxAmount?: Money;
  fee?: Money;

  /**
   * Назначение платежа. Если поле отсутствует, то Плательщик должен указать назначение платежа при составлении распоряжения на перевод по Операции СБП B2B для передачи значения Банком Плательщика в сообщении M05-pacs.008.001.07
   * @example Оплата по договору №123456789 от 01.09.2001
   */
  paymentPurpose?: string;
  sender?: Sender;
}

export interface Sender {
  /**
   * Номер счета юридического лица
   * @example 40702810100010000001
   */
  account: string;

  /**
   * Идентификатор ЮЛ или ИП в ОПКЦ СБП
   * @example LF0000000001
   */
  legalId?: string;
}

export interface ClientConsent {
  hasAgreementWith428CC: boolean;
  hasConfirmationAccuracyOfProvidedInfo: boolean;
  hasAgreementWithMccAssignment: boolean;
  hasAgreementWithReceiveAdvertisingOfPartners: boolean;
  hasAgreementWithReceiveAdvertisingOfBank: boolean;
  hasConfirmedAndAgree: boolean;
}

export interface QrResponse {
  content?: string;
}

export interface B2BPaymentOrderRequest {
  /**
   * Идентификатор Платежной ссылки СБП
   * @example AO1000670LSS7DN18SJQDNP4B05KLJL2
   */
  qrcId: string;

  /**
   * Банковский счет ЮЛ или ИП
   * @example 40702810100010000001
   */
  account: string;

  /**
   * Сумма в копейках
   * @min 10
   * @example 100000
   */
  amount: number;
  totalTaxAmount?: number;

  /** @format int64 */
  fee?: number;
  takeTax: boolean;

  /**
   * Назначение платежа. Если поле отсутствует, то Плательщик должен указать назначение платежа при составлении распоряжения на перевод по Операции СБП B2B для передачи значения Банком Плательщика в сообщении M05-pacs.008.001.07
   * @example Оплата по договору №123456789 от 01.09.2001
   */
  paymentPurpose?: string;
}

export interface PaymentLinkReusableRequest {
  /** Тип QR кода */
  mediaType: "image/png" | "image/svg+xml";

  /**
   * Банковский счет ЮЛ или ИП
   * @example 40702810100010000001
   */
  account: string;

  /**
   * Сумма НДС в копейках. Валюта НДС - рубли РФ. Если поле "takeTax"=false, то поле "totalTaxAmount" не заполняется Получателем. Если поле "takeTax"=true, при этом поле "totalTaxAmount" не заполнено Получателем при регистрации Платежной ссылки СБП B2B, то Плательщик при составлении распоряжения на перевод по Операции СБП B2B должен указать сумму НДС по выполняемой Операции СБП для передачи значения Банком Плательщика в сообщении M05-pacs.008.001.07.
   * @format int64
   * @example 0
   */
  totalTaxAmount?: number | null;

  /**
   * Содержит ссылку для автоматического возврата Плательщика из приложения Банка в приложение или на сайт ТСП. Допускаются только символы в кодировке ASCII. Формат должен соответствовать правилам кодировки URL.
   * @example https://exampletsp.io/qwertyui
   */
  redirectUrl?: string | null;

  /**
   * Информация о взимании НДС. Допустимые значения: true – облагается НДС
   * false – не облагается НДС
   * @example true
   */
  takeTax: boolean;

  /**
   * Идентификатор ТСП
   * @example MF0000000001
   */
  merchantId: string;

  /**
   * Сумма Операции СБП B2B в копейках. Целое, положительное число. Валюта Операции СБП - рубли РФ.
   * @format int64
   * @example 100000
   */
  amount?: number;

  /**
   * Назначение платежа
   * @example example: оплата по договору №123456789 от 01.09.2023
   */
  paymentPurpose?: string;
}

export interface ImageData {
  /**
   * base64encoded image. Формат для декодирования зависит от mediaType
   * @example iVBORw0KGgoAAAANSUhEUgAABEoAAARKCAIAAADXJAK3AAAABmJLR0QA/wD...YII=
   */
  content?: string;
}

export interface PaymentLinkRegistrationResponse {
  /**
   * Идентификатор зарегистрированной Функциональной СБП для B2B
   * @example AO1000670LSS7DN18SJQDNP4B05KLJL2
   */
  qrcId?: string;

  /**
   * Payload зарегистрированной Платежной или Информационной ссылки СБП
   * @example https://b2b.cbrpay.ru/AO1000670LSS7DN18SJQDNP4B05KLJL2
   */
  payload?: string;
  image?: ImageData;
}

export interface PaymentLinkOneOffRequest {
  /** Тип QR кода */
  mediaType: "image/png" | "image/svg+xml";

  /**
   * Банковский счет ЮЛ или ИП
   * @example 40702810100010000001
   */
  account: string;

  /**
   * Сумма НДС в копейках. Валюта НДС - рубли РФ. Если поле "takeTax"=false, то поле "totalTaxAmount" не заполняется Получателем. Если поле "takeTax"=true, при этом поле "totalTaxAmount" не заполнено Получателем при регистрации Платежной ссылки СБП B2B, то Плательщик при составлении распоряжения на перевод по Операции СБП B2B должен указать сумму НДС по выполняемой Операции СБП для передачи значения Банком Плательщика в сообщении M05-pacs.008.001.07.
   * @format int64
   * @example 0
   */
  totalTaxAmount?: number | null;

  /**
   * Содержит ссылку для автоматического возврата Плательщика из приложения Банка в приложение или на сайт ТСП. Допускаются только символы в кодировке ASCII. Формат должен соответствовать правилам кодировки URL.
   * @example https://exampletsp.io/qwertyui
   */
  redirectUrl?: string | null;

  /**
   * Информация о взимании НДС. Допустимые значения: true – облагается НДС
   * false – не облагается НДС
   * @example true
   */
  takeTax: boolean;

  /**
   * Идентификатор ТСП
   * @example MF0000000001
   */
  merchantId: string;

  /**
   * Сумма Операции СБП B2B в копейках. Целое, положительное число. Валюта Операции СБП - рубли РФ.
   * @format int64
   * @min 1
   * @example 100000
   */
  amount: number;

  /**
   * Срок жизни Функциональной ссылки СБП B2B в минутах. Минимальное допустимое значение - "1". Максимальное допустимое значение - "129 600" (90 дней). Если поле "qrTtl" не передано в запросе, будет использовано значение по умолчанию - "4 320" минут (3 суток).
   * @format int32
   * @example 60
   */
  qrTtl?: number | null;

  /**
   * Назначение платежа
   * @example example: оплата по договору №123456789 от 01.09.2023
   */
  paymentPurpose: string;
}

export interface Pageable {
  /**
   * @format int32
   * @min 0
   */
  page?: number;

  /**
   * @format int32
   * @min 1
   */
  size?: number;
  sort?: string[];
}

/**
 * Список подписантов документа
 */
export interface DocumentSignatories {
  /** @format date-time */
  date?: string;
  userId?: string;
  role?: string;
  userName?: string;
}

export interface PagePaymentOperationResponse {
  /** @format int32 */
  totalPages?: number;

  /** @format int64 */
  totalElements?: number;

  /** @format int32 */
  size?: number;
  content?: PaymentOperationResponse[];

  /** @format int32 */
  number?: number;
  sort?: SortObject[];
  first?: boolean;

  /** @format int32 */
  numberOfElements?: number;
  last?: boolean;
  pageable?: PageableObject;
  empty?: boolean;
}

export interface PageableObject {
  /** @format int64 */
  offset?: number;
  sort?: SortObject[];
  paged?: boolean;

  /** @format int32 */
  pageNumber?: number;

  /** @format int32 */
  pageSize?: number;
  unpaged?: boolean;
}

export interface PaymentOperationResponse {
  /** @format uuid */
  id?: string;
  operationType?: "INCOMING" | "OUTGOING";
  status?: OrderStatus;
  legalName?: string;
  brandName?: string;
  bankName?: string;
  inn?: string;
  account?: string;
  amount?: number;
  taxAmount?: number;
  currency?: "RUB";

  /** @format date-time */
  operationDate?: string;
  paymentPurpose?: string;

  /** Список подписантов документа */
  signatories?: DocumentSignatories[];

  /** Признак подписания заявки данным пользователем */
  signatureSet?: boolean;
  externalId?: string;
  takeTax?: boolean;
}

export interface SortObject {
  direction?: string;
  nullHandling?: string;
  ascending?: boolean;
  property?: string;
  ignoreCase?: boolean;
}

export interface PageTerminalServiceResponse {
  /** @format int32 */
  totalPages?: number;

  /** @format int64 */
  totalElements?: number;

  /** @format int32 */
  size?: number;
  content?: TerminalServiceResponse[];

  /** @format int32 */
  number?: number;
  sort?: SortObject[];
  first?: boolean;

  /** @format int32 */
  numberOfElements?: number;
  last?: boolean;
  pageable?: PageableObject;
  empty?: boolean;
}

export interface TerminalServiceResponse {
  /** @format uuid */
  id?: string;
  requestNum?: string;
  requestType?: string;
  requestStatus?: "CREATED" | "IN_PROGRESS" | "COMPLETED";

  /** @format date-time */
  requestDate?: string;
  terminalId?: string;
  terminalNum?: string;

  /** @format date-time */
  resolvePeriod?: string;

  /** @format date-time */
  closeDate?: string;
}

export interface PageSupportOrder {
  /** @format int32 */
  totalPages?: number;

  /** @format int64 */
  totalElements?: number;

  /** @format int32 */
  size?: number;
  content?: SupportOrder[];

  /** @format int32 */
  number?: number;
  sort?: SortObject[];
  first?: boolean;

  /** @format int32 */
  numberOfElements?: number;
  last?: boolean;
  pageable?: PageableObject;
  empty?: boolean;
}

export interface SupportOrder {
  /** @format uuid */
  id?: string;

  /** @format int32 */
  number?: number;
  agreementNumber?: string;
  orderType?: string;
  topicName?: string;
  description?: string;
  status?: OrderStatus;

  /** @format date-time */
  createDate?: string;
}

export interface SupportOrderTopicResponse {
  topicName?: string;

  /** @format uuid */
  topicId?: string;
}

export interface SupportOrderTypeResponse {
  orderTypeName?: string;
  category?: "SERVICE_ORDER" | "CONSULTATION_ORDER";
  topicList?: SupportOrderTopicResponse[];
}

export interface PageStoreTurnover {
  /** @format int32 */
  totalPages?: number;

  /** @format int64 */
  totalElements?: number;

  /** @format int32 */
  size?: number;
  content?: StoreTurnover[];

  /** @format int32 */
  number?: number;
  sort?: SortObject[];
  first?: boolean;

  /** @format int32 */
  numberOfElements?: number;
  last?: boolean;
  pageable?: PageableObject;
  empty?: boolean;
}

export interface StoreTurnover {
  agreementNumber?: string;
  tradeOutletNumber?: string;
  terminalNumber?: string;

  /** @format date */
  date?: string;
  amount?: number;
  currency?: "RUB" | "USD" | "EUR" | "CNY";
}

export interface StoreTradeOutlet {
  number?: string;
  name?: string;
  address?: string;
  agreementNumber?: string;
  status?: string;

  /** @format int32 */
  mcc?: number;

  /** @format int32 */
  terminalQuantity?: number;
}

export interface StoreTerminal {
  number?: string;

  /** @format date-time */
  installationDate?: string;
  status?: string;
  condition?: string;
  affiliation?: string;
}

export interface PageMetadata {
  /** @format int64 */
  size?: number;

  /** @format int64 */
  number?: number;

  /** @format int64 */
  totalElements?: number;

  /** @format int64 */
  totalPages?: number;
}

export interface PagedModelStoreMerchantOperation {
  content?: StoreMerchantOperation[];
  page?: PageMetadata;
}

export interface StoreMerchantOperation {
  contractNumber?: string;
  tradePointCode?: string;
  terminalNumber?: string;

  /** @format date-time */
  operationDate?: string;
  cardType?: string;
  cardNumber?: string;
  operationType?: string;
  operationCancelledNumber?: string;
  operationCurrency?: string;
  operationSum?: number;
  calculationCurrency?: string;
  calculationCommissionPercent?: string;
  calculationCommission?: number;
  calculationSum?: number;

  /** @format date-time */
  calculationDate?: string;
  operationNumber?: string;
  authorizationCode?: string;
}

export interface StoreOrder {
  /** @format uuid */
  id?: string;
  fullClientName?: string;
  shortClientName?: string;
  orgAddress?: string;
  contactPhoneNumber?: string;
  ogrn?: string;
  inn?: string;
  kpp?: string;
  clientEmail?: string;
  storeName?: string;
  storeAddress?: string;
  storeOkato?: string;
  storeWorkMode?: string;
  storeMcc?: string;
  equipmentTypes?: ("POS_TERMINAL" | "ONLINE_CASH_REGISTER")[];
  deviceTypes?: ("STATIC" | "PORTABLE")[];
  connectionTypes?: ("INTERNET" | "SIM" | "WI_FI")[];
  responsiblePersonFullName?: string;
  responsiblePersonPhone?: string;
  emailForFinancialOperations?: string;
  emailForReports?: string;
  checkingAccount?: string;
  bankName?: string;
  bankBik?: string;
  correspondentAccount?: string;
  oktmo?: string;
  okved?: string;
  okpo?: string;
  kbk?: string;
  personalAccount?: string;
  delegateFullName?: string;
  delegatePosition?: string;
  status?: OrderStatus;

  /** @format date-time */
  createDate?: string;
}

export interface CcbBuild {
  orderCcb?: string;
  ccbVersion?: string;
  document?: CcbDocument;
}

export interface CcbDocument {
  fields?: OrderDocument;
  type?: CcbType;
}

export interface CcbType {
  desc?: string;
  name?: string;
}

export interface OrderDocument {
  id?: string;
  clientId?: string;
  customerShortName?: string;
  inn?: string;
  ogrn?: string;
  branchCode?: string;
  orderType?: string;
  createDate?: string;
  brandName?: string;
  account?: string;
  commissionAccount?: string;
  mcc?: string;
  countryCode?: string;
  countrySubDivisionCode?: string;
  city?: string;
  zip?: string;
  address?: string;
  contactPhoneNumber?: string;
  notificationPhoneNumber?: string;
  merchantId?: string;
  fullClientName?: string;
  shortClientName?: string;
  qrcId?: string;
  amount?: string;
  totalTaxAmount?: string;
  paymentPurpose?: string;
  senderLegalId?: string;
  currencyCode?: string;
  agentId?: string;
  memberId?: string;
  legalId?: string;
  fee?: string;
  requestNum?: string;
  orgId?: string;
  basedOn?: string;
  contactPhone?: string;
  contactEmail?: string;
  financialEmail?: string;
  reportEmail?: string;
  reportPeriod?: "DAILY" | "MONTHLY";
  isBudget?: string;
  isLicenseNeeded?: string;
  isSingleRefundForPoints?: string;
  isRefundSingleWithDebit?: string;
  refundPeriod?: string;
  tradePoints?: string;
  contactInfos?: string;
  accountInfos?: string;
  shortNameClient?: string;
  updateDate?: string;
  reviewDate?: string;
}

export interface MerchantDraftDetail {
  /** @format uuid */
  id?: string;
  requestNum?: string;

  /** @format date-time */
  createDate?: string;

  /** @format date-time */
  updateDate?: string;
  status?: OrderStatus;
}

export interface MerchantDraftList {
  isContractExists?: boolean;
  merchantDrafts?: MerchantDraftDetail[];
}

export interface SendToReviewResponse {
  result?: "SUCCESS" | "CRM_UNAVAILABLE" | "CONTRACT_EXISTS";
  description?: string;
}

/**
 * Реквизиты для возмещения, по договору
 */
export interface StoreAgreement {
  companyName?: string;
  number?: string;

  /** @format date-time */
  date?: string;
  tariff?: string;
  tradeOutletQuantity?: string;
  status?: string;
}

export interface StoreAccountAgreement {
  agreementNumber?: string;

  /** @format date-time */
  date?: string;
  companyName?: string;
  bankName?: string;
  accountCorrespondent?: string;
  accountPayment?: string;
  inn?: string;
  bic?: string;
}

export interface Merchant {
  /**
   * Название ТСП (имя по вывеске)
   * @example Кофейня у Артема
   */
  brandName?: string;

  /**
   * Номер счета юридического лица, привязанного к ТСП
   * @example 40702810100010000001
   */
  account?: string;

  /**
   * Номер счета юридического лица, привязанного к ТСП, для списания комиссии
   * @example 40702810100010000001
   */
  commissionAccount?: string;

  /**
   * MCC код
   * @example 4122
   */
  mcc?: string;

  /**
   * Код страны-регистрации юридического лица, в формате "ISO 3166, Alpha-2"
   * @example RU
   */
  countryCode?: string;

  /**
   * Код региона-регистрации юридического лица, первые две цифры кода ОКТМО
   * @example 45
   */
  countrySubDivisionCode?: string;

  /**
   * Город
   * @example Москва
   */
  city?: string;

  /**
   * Индекс
   * @example 115184
   */
  zip?: string;

  /**
   * Фактический адрес ТСП
   * @example УЛИЦА ТАТАРСКАЯ Б. ДОМ 11
   */
  address?: string;

  /**
   * Контактный номер телефона ТСП
   * @example +79991234567
   */
  contactPhoneNumber?: string;

  /**
   * Номер телефона ТСП для отправки уведомлений
   * @example +79991234567
   */
  notificationPhoneNumber?: string;

  /**
   * Идентификатор зарегистрированного ТСП
   * @example MF0000000001
   */
  merchantId?: string;

  /**
   * Дата регистрации ТСП в UTC
   * @format date-time
   */
  enrollTime?: string;
  status?: StatusEntity;

  /** Группа операций ТСП в соответствии с классификатором ЦБ */
  mccGroup?: string;

  /** Признак наличия активной заявки на смену статуса у зарегистрированной ТСП */
  hasActiveOrder?: boolean;
}

export interface MerchantOrder {
  /** @format uuid */
  id?: string;
  orderType?: "REGISTRATION" | "UPDATE" | "ACTIVE" | "BLOCK";
  brandName?: string;
  account?: string;
  commissionAccount?: string;
  mcc?: string;
  countryCode?: string;
  countrySubDivisionCode?: string;
  city?: string;
  zip?: string;
  address?: string;
  contactPhoneNumber?: string;
  notificationPhoneNumber?: string;
  merchantId?: string;
  signatories?: DocumentSignatories[];

  /** Признак подписания заявки данным пользователем */
  signatureSet?: boolean;
  status?: OrderStatus;

  /** @format date-time */
  createDate?: string;
}

export interface ClientStatus {
  status?:
    | "NOT_REGISTERED"
    | "NOT_RESIDENT"
    | "IN_PROCESSING"
    | "ACTIVE"
    | "BLOCKED"
    | "ERROR";
}

export interface LegalEntityOrder {
  /** @format uuid */
  id?: string;

  /** Тип заявки (регистрация / обновление статуса) */
  orderType?: "REGISTRATION" | "UPDATE" | "ACTIVE" | "BLOCK";

  /** Список подписантов */
  signatories?: DocumentSignatories[];

  /** Признак подписания заявки данным пользователем */
  signatureSet?: boolean;

  /** @format date-time */
  createDate?: string;
  status?: OrderStatus;
}

export interface CountryRegion {
  /** Код региона */
  code?: string;

  /** Наименование региона */
  region?: string;
}

export interface MccCode {
  /**
   * МСС код
   * @example 5047
   */
  code?: string;

  /**
   * Наименование вида деятельности
   * @example Медицинское оборудование и расходные материалы
   */
  name?: string;
}

export interface MccGroup {
  /**
   * Название МСС группы
   * @example Оплата услуг медицинских и образовательных учреждений
   */
  groupName?: string;
  mccCodes?: MccCode[];
}

export interface MccResponse {
  mccGroups?: MccGroup[];
}

export interface DocumentFileStatusResponse {
  status?:
    | "CREATE"
    | "TEMP"
    | "ANTIVIRUS"
    | "CLEAN"
    | "REJECT"
    | "DONE"
    | "ERROR";
  description?: string;
}

export interface ClientInfo {
  fullName?: string;
  shortName?: string;
  orgAddress?: string;
  orgPhone?: string;
  orgEmail?: string;
  inn?: string;
  ogrn?: string;
  kpp?: string;
  hasConsent?: boolean;
}

export interface AvailableOperationsResponse {
  availableOperations?: string[];
}

export interface DelegateInfo {
  fullName?: string;
  position?: string;

  /**
   * Адрес делегата
   * @example 161410, обл Вологодская, р-н Кичменгско-Городецкий, д Судническая Гора
   */
  address?: string;

  /**
   * Название ДУЛ
   * @example Паспорт
   */
  dulName?: string;

  /**
   * Номер ДУЛ
   * @example 19 05 380128
   */
  dulNumber?: string;

  /**
   * ДУЛ, кем выдан
   * @example ОВД КИЧМЕНГСКО-ГОРОДЕЦКОГО РАЙОНА ВОЛОГОДСКОЙ ОБЛАСТИ
   */
  dulIssue?: string;

  /**
   * ДУЛ, дата выдачи
   * @format date
   * @example 2006-06-20
   */
  dulIssueDate?: string;
}

/**
 * Получение типа подтверждения
 */
export interface ConfirmTypeResponse {
  /** Тип подтверждения */
  confirmType?: "SMS" | "TOKEN";
}

/**
 * Данные о действующем сертификате
 */
export interface ClientCertificateResponse {
  /** Серийный номер сертификата */
  serial: string;

  /** Имя эмитента сертификата (центра сертификации). */
  issuer: string;

  /** Идентификатор пользователя ДБО ЮЛ, который подписывал документ */
  userId: string;

  /** Идентификатор клиента ДБО ЮЛ */
  clientId: string;
}

export interface Account {
  number?: string;
  balance?: number;
  currency?: string;
  bankName?: string;
  correspondentAccount?: string;
  bik?: string;
}

export interface PaymentLinkInfoResponse {
  /**
   * Идентификатор Платежной ссылки СБП
   * @example AO1000670LSS7DN18SJQDNP4B05KLJL2
   */
  qrcId: string;

  /** Тип Функциональной ссылки СБП для B2B */
  linkType: "REUSABLE" | "ONE_OFF";

  /**
   * Идентификатор Агента ТСП, который зарегистрировал Платежную ссылку СБП
   * @example A00000000001
   */
  agentId: string;

  /**
   * Идентификатор Банка Получателя
   * @example 100000000001
   */
  memberId: string;

  /** Наименование банка получателя */
  bankName: string;

  /**
   * Идентификатор ЮЛ или ИП в ОПКЦ СБП
   * @example LF0000000001
   */
  legalId: string;

  /**
   * Сокращенное наименование ЮЛ или ИП
   * @example ООО Торг
   */
  legalName: string;

  /**
   * ИНН ЮЛ или ИП
   * @example 4285733785
   */
  inn: string;

  /**
   * Идентификатор ТСП
   * @example MR1234567890
   */
  merchantId: string;

  /**
   * Торговое наименование ТСП
   * @example ООО Торг на Б.Татарской
   */
  brandName: string;

  /**
   * Фактический адрес ТСП
   * @example г. Москва, ул. Б.Татарская, д.133, стр.1
   */
  address: string;

  /**
   * МСС код
   * @example 4122
   */
  mcc: string;

  /**
   * Сумма Операции СБП B2B в копейках. Целое, положительное число. Валюта Операции СБП - рубли РФ. Если поле отсутствует, то Плательщик должен указать сумму Операции СБП при составлении распоряжения на перевод по Операции СБП B2B для передачи значения Банком Плательщика в сообщении M05-pacs.008.001.07
   * @format int64
   * @min 1
   * @example 100000
   */
  amount?: number;

  /**
   * Назначение платежа. Если поле отсутствует, то Плательщик должен указать назначение платежа при составлении распоряжения на перевод по Операции СБП B2B для передачи значения Банком Плательщика в сообщении M05-pacs.008.001.07
   * @example Оплата по договору №123456789 от 01.09.2001
   */
  paymentPurpose?: string;

  /**
   * Индикатор Подозрительной Операции Агента ТСП
   * @example 0000000000000000
   */
  fraudScore?: string;

  /**
   * Содержит ссылку для автоматического возврата Плательщика из приложения Банка в приложение или на сайт ТСП. Обязателен, если значение параметра redirectUrl было указано при регистрации Функциональной ссылки СБП. Допускаются только символы в кодировке ASCII. Формат должен соответствовать правилам кодировки URL.
   * @example https://exampletsp.io/qwertyui
   */
  redirectUrl?: string;

  /**
   * Информация о взимании НДС. Допустимые значения:
   *
   * true – облагается НДС
   * false – не облагается НДС
   */
  takeTax: boolean;

  /**
   * Сумма НДС в копейках. Валюта НДС - рубли РФ. Если поле "totalTaxAmount" отсутствует, а поле "takeTax"=true, то Плательщик должен указать сумму НДС по Операции СБП B2B при составлении распоряжения на перевод по Операции СБП B2B для передачи значения Банком Плательщика в сообщении M05-pacs.008.001.07
   * @format int64
   * @example 0
   */
  totalTaxAmount?: number;

  /**
   * Уникальный Идентификатор Платежа, назначаемый Получателем
   * @example 281000670LSS7DN18SJQDNP4B05KLJL2
   */
  uip?: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис QR Эквайринг
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl http://127.0.0.1:8080
 * @contact ООО РСХБ-ИНТЕХ, НДБО ЮЛ, QR Эквайринг <info@rshbintech.ru> (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=173239072)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Заявки в поддержу
     * @name GetSupportOrdersList
     * @summary Получение списка заявок в поддержку
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/support/order
     * @secure
     */
    getSupportOrdersList: (
      query: {
        pageRequest: Pageable;
        category: "SERVICE_ORDER" | "CONSULTATION_ORDER";
      },
      params: RequestParams = {}
    ) =>
      this.request<PageSupportOrder, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/support/order`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки в поддержу
     * @name CreateSupportOrder
     * @summary Создание заявки в поддержку
     * @request POST:/api/owb-ms-prd-qr-acquiring/v1/external/support/order
     * @secure
     */
    createSupportOrder: (
      data: SupportOrderRequest,
      params: RequestParams = {}
    ) =>
      this.request<OrderResponse, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/support/order`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на ТСП в торговом эквайринге
     * @name GetStoreOrders
     * @summary Получение активных заявок
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/store/merchants/order
     * @secure
     */
    getStoreOrders: (params: RequestParams = {}) =>
      this.request<StoreOrder[], ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/store/merchants/order`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на ТСП в торговом эквайринге
     * @name RegistrationStoreOrder
     * @summary Регистрация ТСП в торговом эквайринге
     * @request POST:/api/owb-ms-prd-qr-acquiring/v1/external/store/merchants/order
     * @secure
     */
    registrationStoreOrder: (
      data: StoreOrderRequest,
      params: RequestParams = {}
    ) =>
      this.request<OrderResponse, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/store/merchants/order`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на заключение договора ЮЛ в торговом эквайринге
     * @name GetDraftList
     * @summary Получение списка заявок на заключение договоров ЮЛ ТЭ
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/store/legals/order
     * @secure
     */
    getDraftList: (params: RequestParams = {}) =>
      this.request<MerchantDraftList, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/store/legals/order`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на заключение договора ЮЛ в торговом эквайринге
     * @name SaveDraft
     * @summary Изменение черновика
     * @request POST:/api/owb-ms-prd-qr-acquiring/v1/external/store/legals/order
     * @secure
     */
    saveDraft: (data: MerchantDraft, params: RequestParams = {}) =>
      this.request<MerchantDraft, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/store/legals/order`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на ТСП в QR Эквайринге
     * @name GetOrders
     * @summary Получение активных заявок
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/merchants/order
     * @secure
     */
    getOrders: (params: RequestParams = {}) =>
      this.request<MerchantOrder[], ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/merchants/order`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на ТСП в QR Эквайринге
     * @name RegistrationMerchant
     * @summary Регистрация ТСП
     * @request POST:/api/owb-ms-prd-qr-acquiring/v1/external/merchants/order
     * @secure
     */
    registrationMerchant: (
      data: MerchantRegistrationRequest,
      params: RequestParams = {}
    ) =>
      this.request<OrderResponse, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/merchants/order`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на ТСП в QR Эквайринге
     * @name UpdateMerchant
     * @summary Изменение ТСП
     * @request POST:/api/owb-ms-prd-qr-acquiring/v1/external/merchants/order/{merchantId}
     * @secure
     */
    updateMerchant: (
      merchantId: string,
      data: MerchantUpdateRequest,
      params: RequestParams = {}
    ) =>
      this.request<OrderResponse, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/merchants/order/${merchantId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на ТСП в QR Эквайринге
     * @name ChangeStatusMerchant
     * @summary Изменение статуса ТСП
     * @request POST:/api/owb-ms-prd-qr-acquiring/v1/external/merchants/order/{merchantId}/status
     * @secure
     */
    changeStatusMerchant: (
      merchantId: string,
      data: StatusEntity,
      params: RequestParams = {}
    ) =>
      this.request<OrderResponse, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/merchants/order/${merchantId}/status`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки юр. лиц
     * @name ChangeStatusLegalEntity
     * @summary Изменение статуса зарегистрированного ЮЛ в ЕСПП
     * @request POST:/api/owb-ms-prd-qr-acquiring/v1/external/legals/order/status
     * @secure
     */
    changeStatusLegalEntity: (data: StatusEntity, params: RequestParams = {}) =>
      this.request<OrderResponse, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/legals/order/status`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки юр. лиц
     * @name RegistrationLegalEntity
     * @summary Запрос на регистрацию ЮЛ в ЕСПП
     * @request POST:/api/owb-ms-prd-qr-acquiring/v1/external/legals/order/registration
     * @secure
     */
    registrationLegalEntity: (params: RequestParams = {}) =>
      this.request<OrderResponse, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/legals/order/registration`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочная информация
     * @name GetAddressQuery
     * @summary Запрос в DaData
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/info/address
     * @secure
     */
    getAddressQuery: (query: { query: string }, params: RequestParams = {}) =>
      this.request<FindAddressResponse[], ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/info/address`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочная информация
     * @name GetAddress
     * @summary Запрос в DaData на поиск адреса по любой части адреса
     * @request POST:/api/owb-ms-prd-qr-acquiring/v1/external/info/address
     * @secure
     */
    getAddress: (data: FindAddressRequest, params: RequestParams = {}) =>
      this.request<FindAddressResponse[], ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/info/address`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Методы для работы с файлами
     * @name GetFiles
     * @summary Получение списка файлов
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/file
     * @secure
     */
    getFiles: (query: { documentId: string }, params: RequestParams = {}) =>
      this.request<DocumentFileResponse[], ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/file`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Методы для работы с файлами
     * @name UploadFile
     * @summary Загрузка файла
     * @request POST:/api/owb-ms-prd-qr-acquiring/v1/external/file
     * @secure
     */
    uploadFile: (
      query: {
        documentInfoType:
          | "ACTIVITY_LICENSE"
          | "PDN_ACCEPTANCE"
          | "REGULATION"
          | "ORG_REGULATION"
          | "FOUND_AGREEMENT"
          | "CONTRACT_ORDER_CONFIRM"
          | "EIO_CONFIRM"
          | "EGRUL"
          | "EGRIP"
          | "ACTIVITY_PATENT"
          | "ACTIVITY_CERTIFICATE"
          | "REPRESENTATIVE_LETTER"
          | "SIGN_INSTANCES"
          | "ROOM_RIGHTS"
          | "POINT_PHOTO"
          | "JOIN_REQUEST"
          | "OTHER";
      },
      data: { file: File },
      params: RequestParams = {}
    ) =>
      this.request<DocumentFileResponse, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/file`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Методы для работы с файлами
     * @name LinkFile
     * @summary Привязка файлов к документам
     * @request POST:/api/owb-ms-prd-qr-acquiring/v1/external/file/link
     * @secure
     */
    linkFile: (
      query: { documentId: string; fileIds: string[] },
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/file/link`,
        method: "POST",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Методы для разработки
     * @name GetPaymentOperation
     * @summary Получение данных по операции B2B
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/dev/payment
     * @secure
     */
    getPaymentOperation: (query: { id: string }, params: RequestParams = {}) =>
      this.request<void, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/dev/payment`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Методы для разработки
     * @name CreatePaymentOperation
     * @summary Создание операции B2B перевода
     * @request POST:/api/owb-ms-prd-qr-acquiring/v1/external/dev/payment
     * @secure
     */
    createPaymentOperation: (
      data: PaymentOperationRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/dev/payment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Методы для разработки
     * @name RegisterMerchant
     * @summary РЕГИСТРАЦИЯ ТОРГОВОЙ ТОЧКИ БЕЗ ЗАЯВКИ
     * @request POST:/api/owb-ms-prd-qr-acquiring/v1/external/dev/merchants
     * @secure
     */
    registerMerchant: (
      data: MerchantRegistrationRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/dev/merchants`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Методы для разработки
     * @name GetRegisteredAccounts
     * @summary СПИСОК ЗАРЕГИСТРИРОВАННЫХ СЧЕТОВ
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/dev/accounts
     * @secure
     */
    getRegisteredAccounts: (params: RequestParams = {}) =>
      this.request<string, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/dev/accounts`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Методы для разработки
     * @name RegisterAccount
     * @summary РЕГИСТРАЦИЯ СЧЕТА
     * @request POST:/api/owb-ms-prd-qr-acquiring/v1/external/dev/accounts
     * @secure
     */
    registerAccount: (query: { account: string }, params: RequestParams = {}) =>
      this.request<void, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/dev/accounts`,
        method: "POST",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информация об организации клиента
     * @name ProcessClientConsents
     * @summary Отправка согласий клиента
     * @request POST:/api/owb-ms-prd-qr-acquiring/v1/external/client/consent
     * @secure
     */
    processClientConsents: (data: ClientConsent, params: RequestParams = {}) =>
      this.request<void, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/client/consent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags B2B операции
     * @name ParseQr
     * @summary Распознавание QR кода
     * @request POST:/api/owb-ms-prd-qr-acquiring/v1/external/b2b/qr
     * @secure
     */
    parseQr: (data: { file: File }, params: RequestParams = {}) =>
      this.request<QrResponse, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/b2b/qr`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags B2B переводы
     * @name GetPaymentOperations
     * @summary Получение данных по операциям B2B
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/b2b/payment
     * @secure
     */
    getPaymentOperations: (
      query: {
        pageable: Pageable;
        operationType?: ("INCOMING" | "OUTGOING")[];
        account?: string;
        startDate?: string;
        endDate?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<PagePaymentOperationResponse, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/b2b/payment`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags B2B переводы
     * @name CreatePaymentOrder
     * @summary Создание заявки для B2B перевода
     * @request POST:/api/owb-ms-prd-qr-acquiring/v1/external/b2b/payment
     * @secure
     */
    createPaymentOrder: (
      data: B2BPaymentOrderRequest,
      params: RequestParams = {}
    ) =>
      this.request<OrderResponse, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/b2b/payment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags B2B операции
     * @name RegistrationPaymentLinkReusable
     * @summary Регистрация многоразовой функциональной ссылки СБП для B2B
     * @request POST:/api/owb-ms-prd-qr-acquiring/v1/external/b2b/link/reusable
     * @secure
     */
    registrationPaymentLinkReusable: (
      data: PaymentLinkReusableRequest,
      params: RequestParams = {}
    ) =>
      this.request<PaymentLinkRegistrationResponse, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/b2b/link/reusable`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags B2B операции
     * @name RegistrationPaymentLinkOneOff
     * @summary Регистрация одноразовой функциональной ссылки СБП для B2B
     * @request POST:/api/owb-ms-prd-qr-acquiring/v1/external/b2b/link/one-off
     * @secure
     */
    registrationPaymentLinkOneOff: (
      data: PaymentLinkOneOffRequest,
      params: RequestParams = {}
    ) =>
      this.request<PaymentLinkRegistrationResponse, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/b2b/link/one-off`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags B2B переводы
     * @name GetPaymentOperationsV2
     * @summary Получение данных по операциям B2B
     * @request GET:/api/owb-ms-prd-qr-acquiring/v2/external/b2b/payment
     * @secure
     */
    getPaymentOperationsV2: (
      query: {
        pageable: Pageable;
        operationType?: ("INCOMING" | "OUTGOING")[];
        accounts?: string[];
        startDate?: string;
        endDate?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<PagePaymentOperationResponse, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v2/external/b2b/payment`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на сервисное обслуживание терминалов из СУИТ
     * @name GetTerminalServiceRequestList
     * @summary Получение списка заявок на сервисное обслуживание терминалов из СУИТ
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/support
     * @secure
     */
    getTerminalServiceRequestList: (
      query: {
        pageable: Pageable;
        type?: string;
        status?: "CREATED" | "IN_PROGRESS" | "COMPLETED";
        reqDateFrom?: string;
        reqDateTo?: string;
        closeDateFrom?: string;
        closeDateTo?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<PageTerminalServiceResponse, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/support`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки в поддержу
     * @name GetSupportOrder
     * @summary Получение заявки по ID
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/support/order/{orderId}
     * @secure
     */
    getSupportOrder: (orderId: string, params: RequestParams = {}) =>
      this.request<SupportOrder, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/support/order/${orderId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки в поддержу
     * @name DeleteSupportOrder
     * @summary Удаление заявки
     * @request DELETE:/api/owb-ms-prd-qr-acquiring/v1/external/support/order/{orderId}
     * @secure
     */
    deleteSupportOrder: (orderId: string, params: RequestParams = {}) =>
      this.request<void, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/support/order/${orderId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки в поддержу
     * @name GetSupportOrderTypes
     * @summary Получение списка возможных типов заявок в поддержку
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/support/order/type
     * @secure
     */
    getSupportOrderTypes: (params: RequestParams = {}) =>
      this.request<SupportOrderTypeResponse[], ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/support/order/type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договора торгового эквайринга, торговые точки и терминалы
     * @name GetTurnover
     * @summary Получение суммы денежных поступлений по договору торгового эквайринга
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/store/turnover
     * @secure
     */
    getTurnover: (
      query: {
        pageable: Pageable;
        agreementNumber?: string;
        tradeOutletNumber?: string;
        terminalNumber?: string;
        startAmount?: number;
        endAmount?: number;
        startDate?: string;
        endDate?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<PageStoreTurnover, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/store/turnover`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договора торгового эквайринга, торговые точки и терминалы
     * @name GetTradeOutlets
     * @summary Получение списка зарегистрированных ТСП
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/store/trade-outlet
     * @secure
     */
    getTradeOutlets: (
      query?: { agreementNumber?: string },
      params: RequestParams = {}
    ) =>
      this.request<StoreTradeOutlet[], ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/store/trade-outlet`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договора торгового эквайринга, торговые точки и терминалы
     * @name GetTradeOutlet
     * @summary Получение зарегистрированного ТСП по номеру
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/store/trade-outlet/{number}
     * @secure
     */
    getTradeOutlet: (number: string, params: RequestParams = {}) =>
      this.request<StoreTradeOutlet, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/store/trade-outlet/${number}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договора торгового эквайринга, торговые точки и терминалы
     * @name GetTerminals
     * @summary Получение списка зарегистрированных терминалов
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/store/terminal
     * @secure
     */
    getTerminals: (
      query: { tradeOutletNumber: string; agreementNumber: string },
      params: RequestParams = {}
    ) =>
      this.request<StoreTerminal[], ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/store/terminal`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договора торгового эквайринга, торговые точки и терминалы
     * @name GetOperation
     * @summary Получение данных по операциям ТЭ
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/store/operation
     * @secure
     */
    getOperation: (
      query?: {
        page?: number;
        size?: number;
        sort?: string[];
        contractNumbers?: string[];
        terminalNumber?: string;
        tradePointCode?: string;
        operationFrom?: string;
        operationTo?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<PagedModelStoreMerchantOperation, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/store/operation`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договора торгового эквайринга, торговые точки и терминалы
     * @name GetOperationFile
     * @summary Получение файла операций ТЭ
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/store/operation/file
     * @secure
     */
    getOperationFile: (
      query: {
        fileType: "CSV" | "EXCEL";
        contractNumbers?: string[];
        terminalNumber?: string;
        tradePointCode?: string;
        operationFrom?: string;
        operationTo?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<string, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/store/operation/file`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на ТСП в торговом эквайринге
     * @name GetStoreOrderCcb
     * @summary Получение ККБ заявки
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/store/merchants/order/ccb/{orderId}
     * @secure
     */
    getStoreOrderCcb: (orderId: string, params: RequestParams = {}) =>
      this.request<CcbBuild, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/store/merchants/order/ccb/${orderId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на заключение договора ЮЛ в торговом эквайринге
     * @name GetDraftDetails
     * @summary Получение детальной информации по заявке на заключение договора ТЭ
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/store/legals/order/{requestId}
     * @secure
     */
    getDraftDetails: (requestId: string, params: RequestParams = {}) =>
      this.request<MerchantDraft, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/store/legals/order/${requestId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на заключение договора ЮЛ в торговом эквайринге
     * @name DeleteDraft
     * @summary Удаление заявки в CRM
     * @request DELETE:/api/owb-ms-prd-qr-acquiring/v1/external/store/legals/order/{requestId}
     * @secure
     */
    deleteDraft: (requestId: string, params: RequestParams = {}) =>
      this.request<void, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/store/legals/order/${requestId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на заключение договора ЮЛ в торговом эквайринге
     * @name SendToReview
     * @summary Отправка заявки в CRM
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/store/legals/order/send/{requestId}
     * @secure
     */
    sendToReview: (requestId: string, params: RequestParams = {}) =>
      this.request<SendToReviewResponse, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/store/legals/order/send/${requestId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на заключение договора ЮЛ в торговом эквайринге
     * @name GetReport
     * @summary Генерация PDF файла заявки
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/store/legals/order/report/{requestId}
     * @secure
     */
    getReport: (requestId: string, params: RequestParams = {}) =>
      this.request<File, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/store/legals/order/report/${requestId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на заключение договора ЮЛ в торговом эквайринге
     * @name GetDraftCcb
     * @summary Получение ККБ заявки
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/store/legals/order/ccb/{requestId}
     * @secure
     */
    getDraftCcb: (requestId: string, params: RequestParams = {}) =>
      this.request<CcbBuild, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/store/legals/order/ccb/${requestId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договора торгового эквайринга, торговые точки и терминалы
     * @name GetAgreements
     * @summary Получение списка зарегистрированных договоров
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/store/agreement
     * @secure
     */
    getAgreements: (params: RequestParams = {}) =>
      this.request<StoreAgreement[], ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/store/agreement`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договора торгового эквайринга, торговые точки и терминалы
     * @name GetAccountAgreement
     * @summary Получение реквизитов для возмещения по конкретному договору
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/store/account
     * @secure
     */
    getAccountAgreement: (
      query: { agreementNumber: string },
      params: RequestParams = {}
    ) =>
      this.request<StoreAccountAgreement, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/store/account`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ТСП в ЕСПП
     * @name GetMerchants
     * @summary Получение списка зарегистрированных ТСП
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/merchants
     * @secure
     */
    getMerchants: (params: RequestParams = {}) =>
      this.request<Merchant[], ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/merchants`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ТСП в ЕСПП
     * @name GetMerchant
     * @summary Получение зарегистрированного ТСП по ID
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/merchants/{merchantId}
     * @secure
     */
    getMerchant: (merchantId: string, params: RequestParams = {}) =>
      this.request<Merchant, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/merchants/${merchantId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на ТСП в QR Эквайринге
     * @name GetMerchantOrder
     * @summary Получение заявки
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/merchants/order/{orderId}
     * @secure
     */
    getMerchantOrder: (orderId: string, params: RequestParams = {}) =>
      this.request<MerchantOrder, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/merchants/order/${orderId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на ТСП в QR Эквайринге
     * @name DeleteOrderMerchant
     * @summary Удаление заявки
     * @request DELETE:/api/owb-ms-prd-qr-acquiring/v1/external/merchants/order/{orderId}
     * @secure
     */
    deleteOrderMerchant: (orderId: string, params: RequestParams = {}) =>
      this.request<void, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/merchants/order/${orderId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на ТСП в QR Эквайринге
     * @name GetOrderMerchantCcb
     * @summary Получение ККБ заявки
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/merchants/order/ccb/{orderId}
     * @secure
     */
    getOrderMerchantCcb: (orderId: string, params: RequestParams = {}) =>
      this.request<CcbBuild, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/merchants/order/ccb/${orderId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Юр. лица в ЕСПП
     * @name Status
     * @summary Получение статуса регистрации ЮЛ в ЕСПП
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/legals/status
     * @secure
     */
    status: (params: RequestParams = {}) =>
      this.request<ClientStatus, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/legals/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки юр. лиц
     * @name GetOrder
     * @summary Получение активной заявки ЮЛ
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/legals/order
     * @secure
     */
    getOrder: (params: RequestParams = {}) =>
      this.request<LegalEntityOrder[], ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/legals/order`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки юр. лиц
     * @name GetOrderLegalEntityCcb
     * @summary Получение ККБ заявки ЮЛ
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/legals/order/ccb/{orderId}
     * @secure
     */
    getOrderLegalEntityCcb: (orderId: string, params: RequestParams = {}) =>
      this.request<CcbBuild, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/legals/order/ccb/${orderId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочная информация
     * @name GetListOfCountryRegions
     * @summary Получение списка регионов РФ
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/info/regions
     * @secure
     */
    getListOfCountryRegions: (params: RequestParams = {}) =>
      this.request<CountryRegion[], ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/info/regions`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочная информация
     * @name GetMccCodes
     * @summary Получение списка МСС кодов
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/info/mcc
     * @secure
     */
    getMccCodes: (params: RequestParams = {}) =>
      this.request<MccResponse, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/info/mcc`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Методы для работы с файлами
     * @name GetFile
     * @summary Получение конкретного файла
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/file/{fileId}
     * @secure
     */
    getFile: (fileId: string, params: RequestParams = {}) =>
      this.request<File, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/file/${fileId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Методы для работы с файлами
     * @name DeleteFile
     * @summary Удаление файла
     * @request DELETE:/api/owb-ms-prd-qr-acquiring/v1/external/file/{fileId}
     * @secure
     */
    deleteFile: (fileId: string, params: RequestParams = {}) =>
      this.request<void, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/file/${fileId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Методы для работы с файлами
     * @name GetFileStatus
     * @summary Получение статуса файла
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/file/status/{fileId}
     * @secure
     */
    getFileStatus: (fileId: string, params: RequestParams = {}) =>
      this.request<DocumentFileStatusResponse, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/file/status/${fileId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Методы для разработки
     * @name Test
     * @summary ДЛЯ ТЕСТА URL
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/dev/test
     * @secure
     */
    test: (
      query: { url: string; method: string },
      params: RequestParams = {}
    ) =>
      this.request<string, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/dev/test`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Методы для разработки
     * @name Register
     * @summary ТЕСТОВЫЙ МЕТОД ДЛЯ РЕГИСТРАЦИИ БЕЗ ЗАЯВКИ
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/dev/legals/registration
     * @secure
     */
    register: (params: RequestParams = {}) =>
      this.request<void, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/dev/legals/registration`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Методы для разработки
     * @name Legals
     * @summary СПИСОК ЗАРЕГИСТРИРОВАННЫХ ЮР ЛИЦ
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/dev/legals/all
     * @secure
     */
    legals: (params: RequestParams = {}) =>
      this.request<string, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/dev/legals/all`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Методы для разработки
     * @name LegalsEnrollment
     * @summary ПОЛУЧИТЬ ВСЕ ЮР ЛИЦА В ПРОЦЕССЕ РЕГИСТРАЦИИ
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/dev/enrollments
     * @secure
     */
    legalsEnrollment: (
      query: { operations: string },
      params: RequestParams = {}
    ) =>
      this.request<string, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/dev/enrollments`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Методы для разработки
     * @name Enrollment
     * @summary ИНФО О ЮР ЛИЦЕ НАХОДЯЩЕМСЯ В ПРОЦЕССЕ РЕГИСТРАЦИИ
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/dev/enrollments/{ticketId}
     * @secure
     */
    enrollment: (ticketId: string, params: RequestParams = {}) =>
      this.request<string, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/dev/enrollments/${ticketId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Методы для разработки
     * @name EnrollmentStatus
     * @summary СТАТУС ЮР ЛИЦА НАХОДЯЩЕГОСЯ В ПРОЦЕССЕ РЕГИСТРАЦИИ
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/dev/enrollments/{ticketId}/status
     * @secure
     */
    enrollmentStatus: (ticketId: string, params: RequestParams = {}) =>
      this.request<string, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/dev/enrollments/${ticketId}/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информация об организации клиента
     * @name GetClientInfo
     * @summary Основные данные по клиенту
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/client
     * @secure
     */
    getClientInfo: (params: RequestParams = {}) =>
      this.request<ClientInfo, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/client`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информация об организации клиента
     * @name GetAvailableOperations
     * @summary Доступные бизнес-операции клиента
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/client/operations
     * @secure
     */
    getAvailableOperations: (params: RequestParams = {}) =>
      this.request<AvailableOperationsResponse, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/client/operations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информация об организации клиента
     * @name GetDelegateInfo
     * @summary Основные данные по делегату клиента
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/client/delegate
     * @secure
     */
    getDelegateInfo: (params: RequestParams = {}) =>
      this.request<DelegateInfo, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/client/delegate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информация об организации клиента
     * @name GetConfirmType
     * @summary Получение типа подтверждения клиента
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/client/confirm-type
     * @secure
     */
    getConfirmType: (params: RequestParams = {}) =>
      this.request<ConfirmTypeResponse, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/client/confirm-type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информация об организации клиента
     * @name GetCertificate
     * @summary Получение сертификата клиента
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/client/certificate
     * @secure
     */
    getCertificate: (params: RequestParams = {}) =>
      this.request<ClientCertificateResponse, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/client/certificate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информация об организации клиента
     * @name GetAccounts
     * @summary Получение всех доступных расчетных счетов ЮЛ
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/client/account
     * @secure
     */
    getAccounts: (params: RequestParams = {}) =>
      this.request<Account[], ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/client/account`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags B2B переводы
     * @name GetPayment
     * @summary Получение детальной информации по B2B переводу
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/b2b/payment/{paymentId}
     * @secure
     */
    getPayment: (paymentId: string, params: RequestParams = {}) =>
      this.request<PaymentOperationResponse, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/b2b/payment/${paymentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags B2B переводы
     * @name GetPaymentOrderCcb
     * @summary Получение ККБ исходящего платежа
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/b2b/payment/ccb/{paymentId}
     * @secure
     */
    getPaymentOrderCcb: (paymentId: string, params: RequestParams = {}) =>
      this.request<CcbBuild, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/b2b/payment/ccb/${paymentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags B2B операции
     * @name GetPaymentLink
     * @summary Запрос данных функциональной ссылки СБП для B2B
     * @request GET:/api/owb-ms-prd-qr-acquiring/v1/external/b2b/link
     * @secure
     */
    getPaymentLink: (query: { url: string }, params: RequestParams = {}) =>
      this.request<PaymentLinkInfoResponse, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/b2b/link`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки юр. лиц
     * @name DeleteOrderLegalEntity
     * @summary Удаление заявки ЮЛ
     * @request DELETE:/api/owb-ms-prd-qr-acquiring/v1/external/legals/order/{orderId}
     * @secure
     */
    deleteOrderLegalEntity: (orderId: string, params: RequestParams = {}) =>
      this.request<void, ErrorMessage>({
        path: `/api/owb-ms-prd-qr-acquiring/v1/external/legals/order/${orderId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
}

export const api = new Api();
